import React, { useState } from "react";
import PageHeader from "../components/PageHeader";
import useScrollReveal from "../hooks/useScrollReveal";
import { books, portraits } from "../mock";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../components/ui/dialog";
import { BookOpen, X } from "lucide-react";
import TextToSpeech from "../components/TextToSpeech";

export default function Books() {
  useScrollReveal();
  const [active, setActive] = useState(null);

  return (
    <div>
      <PageHeader
        eyebrow="Publications"
        title="Books"
        subtitle="Four decades of diplomacy distilled into memoir, analysis and imagination — from mythology to Modi, from the United Nations to the nuclear order."
        image={portraits.reading}
      />

      <section className="py-20 bg-[#faf8f4]">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 grid sm:grid-cols-2 gap-8">
          {books.map((b, i) => (
            <article
              key={b.id}
              className="group bg-white rounded-lg border border-[#eae4d8] overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all duration-300 reveal flex"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div className="w-36 sm:w-44 flex-shrink-0 overflow-hidden bg-[#1a2b4a]">
                <img
                  src={b.cover}
                  alt={b.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-6 flex flex-col">
                <p className="text-xs font-semibold text-[#b8935a] tracking-wide">
                  {b.year}
                </p>
                <h3 className="font-serif text-xl font-semibold text-[#1a2b4a] mt-1 leading-snug">
                  {b.title}
                </h3>
                <p className="mt-3 text-sm text-[#5a6070] leading-relaxed line-clamp-4">
                  {b.excerpt}
                </p>
                <button
                  onClick={() => setActive(b)}
                  className="mt-auto pt-4 inline-flex items-center gap-2 text-sm font-medium text-[#b8935a] hover:gap-3 transition-all self-start"
                >
                  <BookOpen size={16} /> Read more
                </button>
              </div>
            </article>
          ))}
        </div>
      </section>

      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent className="max-w-2xl bg-[#faf8f4] border-[#eae4d8]">
          {active && (
            <>
              <DialogHeader>
                <p className="text-xs font-semibold text-[#b8935a] tracking-wide">
                  {active.year}
                </p>
                <DialogTitle className="font-serif text-2xl md:text-3xl text-[#1a2b4a] leading-snug text-left">
                  {active.title}
                </DialogTitle>
              </DialogHeader>
              <div className="flex flex-col sm:flex-row gap-6 mt-2">
                <div className="flex-shrink-0 flex flex-col items-center gap-4">
                  <img
                    src={active.cover}
                    alt={active.title}
                    className="w-32 h-44 object-cover rounded-md shadow-md"
                  />
                  <TextToSpeech text={`${active.title}. ${active.full}`} compact />
                </div>
                <p className="text-[#3a4155] leading-[1.9] text-[15px]">
                  {active.full}
                </p>
              </div>
            </>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
